<template>
  <div>
    <h2 class="text-2xl font-semibold text-gray-700">{{ title }}</h2>
    <div class="flex items-center mt-2">
      <template v-for="(item, index) in breadcrumbs" :key="index">
        <a v-if="item.link" :href="item.link" class="text-gray-600 hover:text-gray-800">{{ item.text }}</a>
        <span v-else class="text-gray-600">{{ item.text }}</span>
        <span v-if="index < breadcrumbs.length - 1" class="mx-2 text-gray-400">•</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  }
}
</script> 